import { createStore } from "zustand/vanilla";

const filterStore = createStore((set, get) => ({
  pages: {},
  pageStates: {},

  setPageFilters: (pageKey, filters) =>
    set((state) => ({
      pages: { ...state.pages, [pageKey]: filters },
    })),

  getPageFilters: (pageKey) => get().pages[pageKey] || null,

  setPageState: (pageKey, pageState) =>
    set((state) => ({
      pageStates: { ...state.pageStates, [pageKey]: pageState },
    })),

  getPageState: (pageKey) => get().pageStates[pageKey] || null,

  clearAll: () => set({ pages: {}, pageStates: {} }),
}));

export default filterStore;
